import { render, staticRenderFns } from "./TresoreriesFlux.vue?vue&type=template&id=50a932a0&scoped=true&"
import script from "./TresoreriesFlux.js?vue&type=script&lang=js&"
export * from "./TresoreriesFlux.js?vue&type=script&lang=js&"
import style0 from "./TresoreriesFlux.vue?vue&type=style&index=0&id=50a932a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a932a0",
  null
  
)

export default component.exports